import React, { Component } from 'react';

import { navigate } from '@reach/router';
import loadImage from 'blueimp-load-image';

import { IAvatarActions } from '../../../../store/avatar/actions';
import { INotificationsActions } from '../../../../store/notification/actions';
import { ILocalMessageState, initialLocalMessageState } from '../../../../store/notification/store';

import Button from '../../../../components/Button';
import { isMobileDevice } from '../../../../contrib/utils';
import { navigateTo } from '../../../../contrib/Utils/navigateTo';

interface IProps {
  actions: {
    avatar: IAvatarActions;
    notifications: INotificationsActions;
  };
}

interface IState {
  message: ILocalMessageState;
  isMobile: boolean | null;
}

class SelectPicture extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.save = this.save.bind(this);

    this.state = {
      isMobile: null,
      message: initialLocalMessageState
    };
  }

  public componentDidMount(): void {
    this.checkDeviceType();
  }

  public checkDeviceType(): void {
    const isMobile = isMobileDevice();
    this.setState({
      isMobile
    });
  }

  public async save(e: any): Promise<any> {
    // const { actions } = this.props;
    const file = e.target.files[0];
    const fx = async (img: any) => {
      this.props.actions.avatar.setBase64(img.toDataURL());
      if (location.pathname === `/staff/profile/select-picture`) {
        navigate('/staff/profile/edit-picture');
      } else {
        navigate('/profile/edit-picture');
      }
    };

    await (loadImage as any)(
      file,
      fx,
      { orientation: true, maxWidth: 600 } // Options
    );
  }

  public render(): JSX.Element {
    const { isMobile } = this.state;

    return (
      <div className="home account-settings wrapper select-picture">
        <div>
          <h2 className="account-title">UPDATE YOUR PICTURE</h2>
          <h5>Show the field what a winner looks like.</h5>
          <p>
            1. Make sure its a close up
            <br />
            2. Take off your sunglasses
            <br />
            3. Smile, would ya?
          </p>
          {!isMobile && (
            <Button
              id="take-pic"
              variant="contained"
              color="primary"
              fullWidth={true}
              className="button button-shadow"
              onClick={navigateTo(
                location.pathname === `/staff/profile/select-picture`
                  ? '/staff/profile/take-picture'
                  : '/profile/take-picture'
              )}
            >
              TAKE A SELFIE
            </Button>
          )}
          <Button
            id="pick-file"
            variant={isMobile ? 'contained' : 'outlined'}
            color="primary"
            fullWidth={true}
            className="button"
          >
            <label htmlFor="account-file-input">
              {isMobile ? `Add a profile picture` : `USE ONE OF MY PHOTOS`}
            </label>
            <input
              type="file"
              id="account-file-input"
              onChange={this.save}
              accept=".jpg,.jpeg,.png"
              hidden={true}
            />
          </Button>
        </div>
      </div>
    );
  }
}

export { SelectPicture };
